<div class="mb-4" [ngClass]="containerClasses">
  <div class="mb-1 text-xs text-gray-500">{{ timestamp }}</div>
  <div [ngClass]="messageClasses">
    {{ content }}
  </div>
  <div class="mt-1 text-xs text-gray-600">{{ sender }}</div>
</div>
